
import EnumSelect from '../../../types/global.d';
import { t } from "@lingui/core/macro";

export enum GroupType {
    MembersGroup = "Members Group",UserGroup = "User Group",
}

export enum GroupTypeDisplay {
    MembersGroup = "MembersGroup",UserGroup = "UserGroup",
}

export const GroupTypePairs = Object.keys(GroupType)
  .map(key=> ({id: key, name: GroupType[key]}));

export function toString(value?: EnumSelect): string {
  return value ? GroupType[value.id] : '';
}

export function toStringDisplay(value?: string): string | undefined {
    switch (value) {
            
        case GroupTypeDisplay.MembersGroup:
            return t`Members Group`;
            
        case GroupTypeDisplay.UserGroup:
            return t`User Group`;
            
        default:
            return undefined;
    }
}
